export default {
    methods: {
        //RECORD
        async insertRecord(enableHookBeforeCreate = false, enableInsertListItemOnRecordCreate = false) {
            try {
                /*
                  run before Create if is defined
                */
                if (enableHookBeforeCreate && this.hookBeforeCreate !== null && typeof this.hookBeforeCreate == 'function') {
                    let res = await this.hookBeforeCreate(this);
                    if (typeof res === 'undefined' || !res) return res;
                }
                /*
                  call to api read
                */
                let data = await this.callToCreate(this.getLocalRecord(), this.getFiles());
                let newRecord = data[this.defaultCreateResultSetName] && data[this.defaultCreateResultSetName][0] ? data[this.defaultCreateResultSetName][0] : null;
                if (newRecord) {
                    if (enableInsertListItemOnRecordCreate) {
                        let newListRecord = data[this.defaultListResultSetName] && data[this.defaultListResultSetName][0] ? data[this.defaultListResultSetName] : null;
                        if (newListRecord) {
                            this.l_list.splice(this.defaultListItemIndexOnRecordCreate, 0, newRecord);
                        } else if (typeof newRecord[`${this.defaultCreateRecordIdNameOutput}`] !== 'undefined') {
                            let requestParameters = {};
                            requestParameters[`${this.defaultCampaignIdName}`] = this.getLocalRecord()[`${this.defaultCampaignIdName}`];
                            requestParameters[`${this.l_defaultListRecordIdNameInput}`] = newRecord[`${this.defaultCreateRecordIdNameOutput}`];
                            let list = await this.callToList(requestParameters);
                            if (list[this.defaultListResultSetName] && list[this.defaultListResultSetName].length > 0) {
                                this.l_list.splice(this.defaultListItemIndexOnRecordCreate, 0, list[this.defaultListResultSetName][0]);
                            }
                        } else {
                            this.$emit('onError', 'the list record can not be added');
                        }
                    }
                    this.$emit('onInsertRecord', newRecord);
                    this.updateLocalRecord({'id': newRecord.id})
                    this.setLocalRecord(this.getLocalRecord());
                    return newRecord; // necesary for  upsertRecord
                } else {
                    if (this.consoleLogs) console.log("dataprovider", this.id);
                    throw `resultset ${this.defaultCreateResultSetName} not found`;
                }
            } catch (err) {
                //This isn't emitting for some reason.
                this.$emit('onError', err);

                // TODO this is a temp solution to show the error_response ONLY on the facility_access modal
                // it will likely be replaced, but TYRONE authorized this direction for now to get it working
                this.updateLocalRecord({'error_response': err[0].error_text});

                //this only runs for developer and related rights
                app.message(`${this.dataSource} - ${this.id} Error: ${err}`, 'danger');
                console.log('KS-APP insertRecord: ', this.id, err);
                throw err;
            }
        },
        async readRecord(campaignId = null, recordId = null, enableHookBeforeRead = false, filters = {}) {
            try {
                if (recordId === null || isNaN(recordId) || campaignId == null) throw 'invalid recordId or campaigId'; //validate recordId
                /*
                  run before Read if is defined
                */
                if (enableHookBeforeRead && this.hookBeforeRead !== null && typeof this.hookBeforeRead == 'function') {
                    let res = await this.hookBeforeRead(this);
                    if (typeof res === 'undefined' || !res) return res;
                }
                /*
                  call to api read
                */
                let data = await this.callToRead(campaignId, recordId, filters);
                let readRecord = data[this.defaultReadResultSetName] && data[this.defaultReadResultSetName][0] ? data[this.defaultReadResultSetName][0] : null;
                if (readRecord) {
                    this.l_result.read = data;
                    this.setLocalRecord(readRecord);
                    let record = this.getLocalRecord();
                    this.$emit('onReadRecord', record);
                } else {
                    if (this.consoleLogs) console.log("dataprovider", this.id);
                    throw `resultset ${this.defaultReadResultSetName} not found`;
                }
            } catch (err) {
                this.$emit('onError', err);
                app.message(`${this.dataSource} - ${this.id} Error: ${err}`, 'danger');
                console.log('KS-APP readRecord: ', this.id, err);
                this.setLocalRecordToNewRecord();
                this.l_result.read = {};
                throw err;
            }
        },
        async upsertRecord(write_nulls = 1) {
            try {
                let validate_response = await this.validateDataForms();
                if (validate_response) {
                    if (this.isLocalRecordNewRecord()) {
                        let newRecord = await this.insertRecord(true, this.enableInsertListItemOnRecordCreate);
                        return {'type': 'create', 'data': newRecord};
                    } else {
                        let updateRecord = await this.updateRecord(true, this.enableUpdateListItemOnRecordUpdate, write_nulls);
                        return {'type': 'update', 'data': updateRecord};
                    }
                } else {
                    throw 'Invalid Inputs';
                }
            } catch (err) {
                throw err;
            }
        },
        async updateRecord(enableHookBeforeUpdate = false, enableUpdateListItemOnRecordUpdate = false, write_nulls = 1) {
            try {
                /*
                  run before Update if is defined
                */
                if (enableHookBeforeUpdate && this.hookBeforeUpdate !== null && typeof this.hookBeforeUpdate == 'function') {
                    let res = await this.hookBeforeUpdate(this);
                    if (typeof res === 'undefined' || !res) return res;
                }
                /*
                  call to api update
                */

                let record = this.getLocalRecord();
                if (!record[this.l_defaultUpdateRecordIdNameInput]) {
                    if (!record[this.defaultReadRecordIdNameOutput]) {
                        throw Error('Missing ID');
                    } else {
                        record[this.l_defaultUpdateRecordIdNameInput] = record[this.defaultReadRecordIdNameOutput]
                    }
                }

                let data = await this.callToUpdate(record, this.getFiles(), write_nulls);
                this.setLocalRecord(record);
                /*
                  update list record if is enabled
                */

                if (enableUpdateListItemOnRecordUpdate) {
                    let res = await this.updateListItem(data);
                    if (!res) this.$emit('onError', 'the list record can not be updated');
                }
                /*
                  validate update ResultSet
                */
                let updatedRecord = data[this.defaultUpdateResultSetName] && data[this.defaultUpdateResultSetName][0] ? data[this.defaultUpdateResultSetName] : null;
                if (updatedRecord) {
                    this.$emit('onUpdateRecord', updatedRecord);
                    return updatedRecord; // necesary for  upsertRecord
                } else {
                    console.log("dataprovider", this.id);
                    throw `resultset ${this.defaultUpdateResultSetName} not found`;
                }
            } catch (err) {
                this.$emit('onError', err);

                // TODO this is a temp solution to show the error_response ONLY on the facility_access modal
                // it will likely be replaced, but TYRONE authorized this direction for now to get it working
                this.updateLocalRecord({'error_response': err[0].error_text});

                app.message(`${this.dataSource} - ${this.id} Error: ${err}`, 'danger');
                throw err;
            }
        },
        async updatePartialRecord(campaigId = null, recordId = null, inputs = {}, files = [], enableHookBeforeUpdate = false, enableUpdateListItemOnRecordUpdate = false) {
            try {
                /*
                  run before Update if is defined
                */
                if (enableHookBeforeUpdate && this.hookBeforeUpdate !== null && typeof this.hookBeforeUpdate == 'function') {
                    let res = await this.hookBeforeUpdate(this);
                    if (typeof res === 'undefined' || !res) return res;
                }
                /*
                  verify nulls
                */
                let writeNulls = 0;
                for (const input in inputs) {
                    if (inputs[input] == null) {
                        writeNulls = 1;
                        break;
                    }
                }
                /*
                  if has nulls read the record and enable write nulls
                */
                if (writeNulls == 1) {
                    let data = await this.callToRead(campaigId, recordId);
                    if (data[this.defaultReadResultSetName] && data[this.defaultReadResultSetName][0]) {
                        inputs = {...data[this.defaultReadResultSetName][0], ...inputs};
                    } else {
                        console.log("dataprovider", this.id);
                        throw `resultset ${this.defaultReadResultSetName} not found`;
                    }
                }
                /*
                  call to api update
                */
                inputs[this.l_defaultUpdateRecordIdNameInput] = recordId;
                inputs[this.defaultCampaignIdName] = campaigId;
                let data = await this.callToUpdate(inputs, files, writeNulls);
                /*
                  update list record if is enabled
                */
                if (enableUpdateListItemOnRecordUpdate) {
                    let res = await this.updateListItem(data);
                    if (!res) this.$emit('onError', 'the list record can not be updated');
                }
                /*
                  validate update ResultSet
                */
                let updatedRecord = data[this.defaultUpdateResultSetName] && data[this.defaultUpdateResultSetName][0] ? data[this.defaultUpdateResultSetName] : null;
                if (updatedRecord) {
                    this.$emit('onUpdateRecord', updatedRecord);
                    return updatedRecord;
                } else {
                    console.log("dataprovider", this.id);
                    throw `resultset ${this.defaultUpdateResultSetName} not found`;
                }
            } catch (err) {
                app.message(`${this.dataSource} - ${this.id} Error: ${err}`, 'danger');
                this.$emit('onError', err);
                throw err;
            }
        },
        async deleteRecord(campaignId = null, recordId = null, enableHookBeforeDelete = false, enableDeleteListItemOnRecordDelete = false) {
            try {
                if (recordId == null || isNaN(recordId) || campaignId == null) throw 'invalid recordId or campaigId'; //validate recordId and camapignId
                /*
                  run before delete if is defined
                */
                if (enableHookBeforeDelete && this.hookBeforeDelete !== null && typeof this.hookBeforeDelete == 'function') {
                    let res = await this.hookBeforeDelete(this);
                    if (typeof res === 'undefined' || !res) return res;
                }
                /*
                  call to api delete
                */
                let data = await this.callToDelete(campaignId, recordId);
                let deletedRecord = data[this.defaultDeleteResultSetName] && data[this.defaultDeleteResultSetName][0] ? data[this.defaultDeleteResultSetName][0] : null;
                if (deletedRecord) {
                    if (enableDeleteListItemOnRecordDelete) {
                        this.l_list.splice(this.getSelectedListItemIndex(), 1);
                    }
                    this.$emit('onDeleteRecord', deletedRecord);
                    return deletedRecord;
                } else {
                    console.log("dataprovider", this.id);
                    throw `resultset ${this.defaultDeleteResultSetName} not found`;
                }
            } catch (err) {
                app.message(`${this.dataSource} - ${this.id} Error: ${err}`, 'danger');
                console.log('KS-APP: ', this.id, err);
                this.$emit('onError', err);
                throw err;
            }
        }
    }
}
